<template>
  <div>
    <div v-for="(faq, index) in faqs" :key="index">
      <h2 v-if="h_level == 2" v-bind:id="faq.question.replace(/\s+/g, '-')">{{ faq.question }}</h2>
      <h3 v-else v-bind:id="faq.question.replace(/\s+/g, '-')">{{ faq.question }}</h3>
      <div class="pb-5" v-if="index != Object.keys(faqs).length - 1">
        <p v-html="faq.answer"></p>
      </div>
      <div v-else>
        <p v-html="faq.answer"></p>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'FAQs',
  props: {
    faqs: { type: Array, required: true },
    h_level: { type: Number, required: false }
  },
  created () {
    for (let i = 0; i < this.faqs.length; i++) {
      const faq = {
        '@type': 'Question',
        name: this.faqs[i].question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: this.faqs[i].answer
        }
      }

      this.faqs_json.mainEntity.push(faq)
    }
  },
  data () {
    return {
      faqs_json: {
        '@context': 'https://schema.org',
        '@type': 'FAQPage',
        mainEntity: []
      }
    }
  },
  mounted () {
    const script = document.createElement('script')
    script.type = 'application/ld+json'
    script.text = JSON.stringify(this.faqs_json)
    this.$el.appendChild(script)
  }
}
</script>
